export default __webpack_public_path__ + "static/media/icons8-open-end-wrench.e7ff2b88.svg";